import React, { memo, useMemo } from "react";
import * as Styles from "./UsedStockCars.styles";
import { ComponentRegistryProvider } from "./componentRegistry";
import UsedStockCarsBase from "./UsedStockCarsBase";
import { aemLexusUscModalMap } from "./modals/modals";
import { MODAL_VEHICLE_FOR_SALE_ID } from "../../../shared-logic/utils/modalConstants";
import { getUscExtraQueryBuilderOptions } from "../../../shared-logic/utils/uscUtils";
import useStatus from "../../../../common-deprecated/hooks/useStatus";
import { getRetailerDebugToggleLink } from "../../../../common-deprecated/utils";
import { useModalMap } from "../../../../common-deprecated/containers/ModalProvider";
import { useUscSelector } from "../../redux/store";
import PdpDealer from "./pdp/dealer/PdpDealer";
import { useUscLabel } from "../../utils/labels";
import SaveButton from "./common/basket/common/SaveButton";
import UscBasketCtas from "./common/basket/common/UscBasketCtas";
import Breadcrumbs from "./common/Breadcrumbs";
import ServicesWithDetailsList from "./common/ServicesWithDetailsList";
import UscFinanceOptionsButton from "./common/basket/common/UscFinanceOptionsButton";
import SimilarCars from "./pdp/similar-car/SimilarCars";
import Sidebar from "./styles/atoms/Sidebar";
import { getUscToolsModalItems } from "../../utils/helpers";
import { MODAL_USC_DEBUG } from "../../utils/modalConstants";

const UsedStockCars = (): JSX.Element => {
    const uscSettings = useUscSelector((state) => state.uscSettings);
    const commonSettings = useUscSelector((state) => state.commonSettings);
    const additionalLinks = getUscToolsModalItems();
    const extraQueryBuilderOptions = getUscExtraQueryBuilderOptions(commonSettings);
    const ariaPdpContainerLabel = useUscLabel("uscAriaPdpContainer");
    useStatus(
        commonSettings,
        "USC",
        [...additionalLinks, getRetailerDebugToggleLink()],
        [
            { key: "f", settings: { type: MODAL_USC_DEBUG } },
            {
                key: "i",
                settings: {
                    type: MODAL_VEHICLE_FOR_SALE_ID,
                    detailPageUrl: uscSettings.detailPageUrl,
                    landingPageUrl: uscSettings.landingPageUrl,
                },
            },
        ],
        extraQueryBuilderOptions,
    );
    useModalMap(aemLexusUscModalMap);

    const componentRegistry = useMemo(
        () => ({
            Breadcrumbs,
            PdpDealer,
            ServicesWithDetailsList,
            SaveButton,
            UscBasketCtas,
            UscFinanceOptionsButton,
            SimilarCars,
            UscQrCode: memo(() => null),
            Sidebar,
        }),
        [],
    );

    return (
        <Styles.Wrapper id="usc" aria-label={ariaPdpContainerLabel}>
            <ComponentRegistryProvider registry={componentRegistry}>
                <UsedStockCarsBase />
            </ComponentRegistryProvider>
        </Styles.Wrapper>
    );
};

export default UsedStockCars;
